import { cx } from '../outils';

/** Caractères minuscules agrandis pour rester visibles (fc-touche--glyphe). */
const GLYPHES = new Set(['`', '^', '¨', '´', '~', "'", ',', '.']);

export interface ToucheProps {
  /** Caractère tel qu'il est gravé sur le clavier de l'utilisateur (« L », « ù », « Espace »). */
  children: string;
  /** Attente d'une nouvelle touche pendant le réglage des touches. */
  attente?: boolean;
  className?: string;
}

/** Montre une touche de clavier à côté de l'action qu'elle déclenche (décorative). */
export function Touche({ children, attente = false, className }: ToucheProps) {
  return (
    <kbd
      aria-hidden="true"
      className={cx(
        'fc-touche',
        GLYPHES.has(children) && 'fc-touche--glyphe',
        attente && 'fc-touche--attente',
        className,
      )}
    >
      {children}
    </kbd>
  );
}

/** Raccourci au format de `aria-keyshortcuts` (« ⌘ Z » → « Meta+Z »). */
export function raccourciAria(raccourci: string): string {
  const noms: Record<string, string> = {
    '⌘': 'Meta',
    '⌃': 'Control',
    '⌥': 'Alt',
    '⇧': 'Shift',
    Espace: 'Space',
    Entrée: 'Enter',
    Échap: 'Escape',
  };
  return raccourci
    .split(/[\s ]+/)
    .filter(Boolean)
    .map((partie) => noms[partie] ?? partie)
    .join('+');
}
